exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bim-tag__text[data-v-50ae9498],\n.bim-tag[data-v-50ae9498] {\n  display: inline-block;\n}\n.bim-tag[data-v-50ae9498] {\n  border: 1px solid #00afa1;\n  color: #00afa1;\n  border-radius: 2px;\n}\n.bim-tag.hover-effect[data-v-50ae9498]:hover {\n  background-color: #00afa1;\n  color: #ffffff;\n}\n.bim-tag__text[data-v-50ae9498] {\n  padding: 4px 8px;\n}", ""]);

// exports
